import { MOTION_VAR } from './motion';

/**
 * Marker/dot TONE → colour, shared by the surfaces that draw a status dot (the
 * map sheet, the detail Live tab, the list rows, the dashboard fleet preview).
 * The dot is a VISUAL freshness tone derived from `markerTone` (the `motion`
 * field), NOT a rendered word — the customer-facing WORDS are the vehicle-state
 * vocabulary (`vehicleState.ts` / `VehicleStateLine.tsx`, slice 13e).
 *
 * 🔴 SLICE 23 — these are `var(--raad-*)` STRINGS (`MOTION_VAR`), not resolved
 * hex. A theme toggle re-points every dot through the CSS cascade with no
 * re-render and no import-time freeze; dark renders byte-identically because the
 * var resolves to the same dark token value it used to be read from.
 */
export const TONE_DOT_COLOR = MOTION_VAR;
